import { IRequestValues } from '../saveProfile'

export default function(item: IRequestValues): IRequestBody & { id: number } {
  return {
    /* eslint-disable @typescript-eslint/camelcase */
    city: item.city,
    company_city: item.companyCity,
    company_country: item.companyCountry,
    company_name: item.companyName,
    company_post_code: item.companyPostCode,
    company_street: item.companyStreet,
    company_vat_number: item.companyVatNumber,
    country: item.idCountry,
    email: item.email,
    facebook: item.facebook,
    id: item.id,
    id_currency: item.idCurrency,
    name: item.name,
    phone: item.phone,
    post_code: item.postCode,
    street: item.street,
    swift: item.swift,
    ta_account_number: item.accountNumber,
    type: item.type,
    www: item.www,
    /* eslint-enable */
  }
}

export interface IRequestBody {
  id_user?: number
  id_calendar?: number
  id_currency?: number

  lon?: string
  lat?: string

  company_name?: string
  company_country?: number
  company_city?: string
  company_street?: string
  company_post_code?: string
  company_vat_number?: string

  name?: string
  country?: number
  post_code?: string
  city?: string
  street?: string
  email?: string
  phone?: string
  phone2?: string
  www?: string
  online?: number

  swift?: string
  facebook?: string
  type?: number
  ta_account_number?: string
}
